<div class="col-md-12 grid-margin stretch-card">
  <div class="card">
    <div class="card-body">
      <div class="text-success h6 text-right">
        <a [routerLink]="['/v/dashboard/home']"style="color: black;"title="Back To Home"><i class="fa fa-arrow-left"></i>&nbsp;Back To Home</a>
      </div>
      <ol class="breadcrumb rv-breadcrumb">
        <li class="breadcrumb-item">
          <a class="" style="color:#fff;" routerLink="/v/dashboard/home">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a class="rv-active">Profile</a>
        </li>
      </ol>

      <h4 class="card-title mt-3">My Profile </h4>
      <div class="main-body" *ngFor="let item of arr_profile">
        <div class="row col-md-12 p-0 m-0">
          <div class="col-md-4  left-photoblock">
            <div class="d-flex flex-column align-items-center text-center ">
              <img
                src="../../assets/images/profile.png"
                alt="Admin" class="rounded-circle" width="150">
              <div class="mt-3">
                <h4>{{item.Name}}</h4>
                <p class="text-secondary mb-1">{{item.Role}}</p>
                <p class="text-muted font-size-sm">{{item.Address}}</p>
              </div>
            </div>
          </div>
          <div class="col-md-8 right-infoblock">
            <div class=" ">
              <div class="row info-d">
                <div class="col-sm-3">
                  <h6 class="mb-0">Full Name</h6>
                </div>
                <div class="col-sm-9 text-secondary">
                  {{item.Name}}
                </div>
              </div>
            
              <div class="row info-d">
                <div class="col-sm-3">
                  <h6 class="mb-0">Email</h6>
                </div>
                <div class="col-sm-9 text-secondary">
                  {{item.Email}}
                </div>
              </div>
             
              <div class="row info-d">
                <div class="col-sm-3">
                  <h6 class="mb-0">Mobile No</h6>
                </div>
                <div class="col-sm-9 text-secondary">
                  {{item.MobileNo}}
                </div>
              </div>
         
              <div class="row info-d">
                <div class="col-sm-3">
                  <h6 class="mb-0">Whatsapp No</h6>
                </div>
                <div class="col-sm-9 text-secondary">
                  {{item.WhatsappNo}}
                </div>
              </div>
          
              <div class="row info-d">
                <div class="col-sm-3">
                  <h6 class="mb-0">Address</h6>
                </div>
                <div class="col-sm-9 text-secondary">
                  {{item.Address}}
                </div>
              </div>
             
              <div class="row info-d">
                <div class="col-sm-3">
                  <h6 class="mb-0">Account Valid Till</h6>
                </div>
                <div class="col-sm-9 text-secondary">
                  {{item.ValidDate}}
                </div>
              </div>
           
            </div>
          </div>
          <!-- <div class="counter">
            <div class="row">
              <div class="col-6 col-lg-3">
                <div class="count-data text-center">
                  <h6 class="count h2" data-to="500" data-speed="500">{{item.PaperRequested}}</h6>
                  <p class="m-0px font-w-600">Paper Requested</p>
                </div>
              </div>
              <div class="col-6 col-lg-3">
                <div class="count-data text-center">
                  <h6 class="count h2" data-to="150" data-speed="150">{{item.PaperCompleted}}</h6>
                  <p class="m-0px font-w-600">Paper Completed</p>
                </div>
              </div>
              <div class="col-6 col-lg-3">
                <div class="count-data text-center">
                  <h6 class="count h2" data-to="850" data-speed="850">{{item.PaperPrintRequest}}</h6>
                  <p class="m-0px font-w-600">Paper Print Request</p>
                </div>
              </div>
              <div class="col-6 col-lg-3">
                <div class="count-data text-center no-border">
                  <h6 class="count h2" data-to="190" data-speed="190">{{item.PaperPrinted}}</h6>
                  <p class="m-0px font-w-600">Paper Printed</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>